import { render } from "./ProcurementDashboard.vue?vue&type=template&id=6117b26e&scoped=true"
import script from "./ProcurementDashboard.vue?vue&type=script&lang=js"
export * from "./ProcurementDashboard.vue?vue&type=script&lang=js"

import "./ProcurementDashboard.vue?vue&type=style&index=0&id=6117b26e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6117b26e"]])

export default __exports__